import React from "react";
import { Button } from "@components/shared";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as c from "./medIntegrationSection.module.scss";
import classNames from "classnames";

const MedIntegrationSection = () => {
  const data = useStaticQuery(graphql`
    query MedIntegrationLogos {
      shopify: file(relativePath: { eq: "integrations/shopify.png" }) {
        childImageSharp {
          gatsbyImageData(width: 127, formats: [AUTO, WEBP, AVIF])
        }
      }
      webhooks: file(relativePath: { eq: "integrations/webhooks.png" }) {
        childImageSharp {
          gatsbyImageData(width: 150, formats: [AUTO, WEBP, AVIF])
        }
      }
      docovia: file(relativePath: { eq: "integrations/docovia.png" }) {
        childImageSharp {
          gatsbyImageData(width: 154, formats: [AUTO, WEBP, AVIF])
        }
      }
      doxy: file(relativePath: { eq: "integrations/doxy.me.png" }) {
        childImageSharp {
          gatsbyImageData(width: 154, formats: [AUTO, WEBP, AVIF])
        }
      }
    }
  `);

  const logos = [
    { id: "docovia", image: data.docovia },
    { id: "doxy", image: data.doxy },
    { id: "shopify", image: data.shopify },
    { id: "webhooks", image: data.webhooks },
  ];

  return (
    <div className={c.container}>
      <div className={c.content}>
        <h3 className="h3">One platform. Endless connections.</h3>
        <p className={classNames(c.description, "p3")}>
          Mangomint integrates with industry leaders like{" "}
          <a href="https://doxy.me" target="_blank" rel="noreferrer" className={c.link}>
            Doxy.me
          </a>
          ,{" "}
          <a href="https://docovia.com" target="_blank" rel="noreferrer" className={c.link}>
            Docovia
          </a>
          , and{" "}
          <a href="https://mailchimp.com" target="_blank" rel="noreferrer" className={c.link}>
            Mailchimp
          </a>{" "}
          to give your IV business the flexibility and power it needs—without the complexity.
        </p>

        <div className={c.logos}>
          {logos.map(({ id, image }) => (
            <GatsbyImage key={id} image={getImage(image)} alt={`${id} logo`} />
          ))}
        </div>

        <Button className={c.button} to="/integrations">
          Learn more about integrations
        </Button>
      </div>
    </div>
  );
};

export default MedIntegrationSection;
